import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  private querySubject = new Subject<boolean>();

  constructor() {}

  public refetch() {
    this.querySubject.next(true);
  }

  public getQuerySubject() {
    return this.querySubject;
  }
}



// WEBPACK FOOTER //
// ./src/services/table.service.ts